import React from 'react';
import { CButton, CSpinner } from '@coreui/react';
import CIcon from '@coreui/icons-react';
import { cilSearch, cilWarning, cilReload, cilSad } from '@coreui/icons';

const EmptyState = ({ icon, title, message, actionLabel, onAction, isLoading, type = 'empty' }) => {
  const icons = {
    empty: cilSearch,
    error: cilWarning,
    'no-results': cilSad,
  };

  const IconComponent = icon || icons[type] || cilSearch;

  return (
    <div className="d-flex flex-column align-items-center justify-content-center py-5 px-3 text-center" style={{ minHeight: '250px' }}>
      <div className="p-3 rounded-circle bg-light d-flex align-items-center justify-content-center mb-3" style={{ width: '64px', height: '64px' }}>
        <CIcon icon={IconComponent} size="xl" className={type === 'error' ? 'text-danger' : 'text-muted'} />
      </div>
      <h6 className="fw-bold text-dark mb-1">{title || 'Sin resultados'}</h6>
      <p className="text-muted small mb-3" style={{ maxWidth: '360px' }}>
        {message || 'No se encontraron elementos para mostrar.'}
      </p>
      {actionLabel && onAction && (
        <CButton color={type === 'error' ? 'danger' : 'primary'} size="sm" onClick={onAction} disabled={isLoading} className="px-4">
          {isLoading ? <CSpinner size="sm" className="me-2" /> : <CIcon icon={cilReload} className="me-2" />}
          {actionLabel}
        </CButton>
      )}
    </div>
  );
};

export default React.memo(EmptyState);
